// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DateMbOutlinedSvg from "@fishx/icons-svg/es/asn/DateMbOutlined";
import FishxIcon from '../components/FishxIcon';

var DateMbOutlined = function DateMbOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DateMbOutlinedSvg
  }));
};

DateMbOutlined.displayName = 'DateMbOutlined';
export default React.forwardRef(DateMbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DateMbOutlined.js
// module id = 2386
// module chunks = 0